import { useReactiveVar } from "@apollo/client";
import React from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { unlockWhiteLabelModalVar } from "../../../graphql/globalVar/state";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";

import { UNLOCK_WHITELABEL_FEATURES } from "./constants";
import unlockWhiteLabelImg from "./img/unlock-white-label.webp";

function UnlockWhiteLabelModal() {
  const { t } = useTranslation();
  const show = useReactiveVar<boolean>(unlockWhiteLabelModalVar);
  const locale = useGetUrlLocale();

  const handleClose = () => unlockWhiteLabelModalVar(false);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="modal-stop-tickets-sale"
      contentClassName="rounded-4 border-0"
    >
      <Modal.Header closeButton className="border-0 p-3 pb-0" />
      <Modal.Body className="text-center p-3 pt-0">
        <img
          className="img-fluid mb-4"
          src={unlockWhiteLabelImg}
          alt=""
          width={136}
          height={113}
        />
        <h4 className="fs-4 fs-md-2 text-dark fw-bold mb-2">
          {t("events.modals.unlockWhiteLabel.title")}
        </h4>
        <p className="fs-6 text-info mb-4 px-md-5 mx-lg-4">
          {t("events.modals.unlockWhiteLabel.subtitle")}
        </p>
        <div className="border rounded-4 text-start overflow-hidden">
          {UNLOCK_WHITELABEL_FEATURES.map(
            ({ icon: Icon, titleKey, descriptionKey }, index) => (
              <div
                key={titleKey}
                className={`d-flex align-items-start gap-3 p-3 ${
                  index > 0 ? "border-top" : ""
                }`}
              >
                <div
                  className="flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle bg-success-bg text-success"
                  style={{ width: 40, height: 40 }}
                >
                  <Icon size={20} />
                </div>
                <div>
                  <div className="text-dark fs-6">{t(titleKey)}</div>
                  <div className="text-muted fs-7">{t(descriptionKey)}</div>
                </div>
              </div>
            )
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 w-100 pt-0 px-3 pb-3">
        <Row className="g-2 w-100 m-0">
          <Col xs={12}>
            <Link
              to={`${locale}/payment`}
              className="btn btn-success w-100 py-2 lh-lg rounded-3 fw-bold text-white text-decoration-none mb-1"
              onClick={handleClose}
            >
              {t("events.modals.unlockWhiteLabel.viewPlans")}
            </Link>
          </Col>
          <Col xs={12}>
            <button
              type="button"
              className="btn btn-link w-100 p-0 text-info text-decoration-underline"
              onClick={handleClose}
            >
              {t("events.modals.unlockWhiteLabel.maybeLater")}
            </button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

export default UnlockWhiteLabelModal;
